<ng-container *ngIf="ready">

  <p><span style="font-weight:bold">Proveedor:</span> {{investment.provider}}</p>
  <p><span style="font-weight:bold">Descripción elemento:</span> {{investment.elementDescription}}</p>
  <p><span style="font-weight:bold">Fecha de compra:</span> {{investment.dateBuy | date }}</p>
  <p><span style="font-weight:bold">Tiempo de vida:</span> {{investment.lifetime}} año(s)</p>
  <p><span style="font-weight:bold">Valor residual:</span> {{investment.residualValue}} </p>
  <p><span style="font-weight:bold">Precio de compra:</span> {{investment.totalWithoutTax}} </p>

  <p>Cuota al mes de <span style="font-weight: bold"> {{cuota}} </span> durante<span style="font-weight:bold"> {{
      investment.maximumPeriod}} años</span>.</p>
  <table mat-table border="2" class="mat-elevation-z8">
    <tr>
      <td align="center">Enero</td>
      <td align="center">Febrero</td>
      <td align="center">Marzo</td>
      <td align="center">Abril</td>
      <td align="center">Mayo</td>
      <td align="center">Junio</td>
      <td align="center">Julio</td>
      <td align="center">Agosto</td>
      <td align="center">Septiembre</td>
      <td align="center">Octubre</td>
      <td align="center">Noviembre</td>
      <td align="center">Diciembre</td>
    </tr>
    <tr>
      <td align="center">{{enero}}</td>
      <td align="center">{{enero}}</td>
      <td align="center">{{enero}}</td>
      <td align="center">{{enero}}</td>
      <td align="center">{{enero}}</td>
      <td align="center">{{enero}}</td>
      <td align="center">{{enero}}</td>
      <td align="center">{{enero}}</td>
      <td align="center">{{enero}}</td>
      <td align="center">{{enero}}</td>
      <td align="center">{{enero}}</td>
      <td align="center">{{enero}}</td>
    </tr>
  </table>

</ng-container>
